export default {
  ENTER_USER_FIRSTNAME_LASTNAME: "ENTER_USER_FIRSTNAME_LASTNAME",
};
